import React from "react";
import { Form, Table } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { FaFilter, FaFileExport } from "react-icons/fa6";
import UseToggle from "../../../../Hooks/UseToggle";
import AddNewRequest from "./AddNewRequest";
import FilterRequestAccess from "./FilterRequestAccess";
import SplitPane from "react-split-pane";

const AccessRequestPortal = ({ tableRef }) => {
  const toggles = UseToggle();

  // --- Static data for the table ---
  const requests = [
    {
      id: "AR-2026-0006",
      submitted: "24 Aug 2026",
      time: "13:14",
      study: "GBX-2109",
      studyName: "Phase I SAD/MAD — GBX-119 Healthy Volunteers",
      applications: ["Safety Database"],
      roles: ["Admin"],
      status: "Rejected",
      requestType: "New Access",
      sponsor: "Northwind Therapeutics",
    },
    {
      id: "AR-2026-0005",
      submitted: "24 Aug 2026",
      time: "11:45",
      study: "GBX-2201",
      studyName: "Phase III Ustekinumab in Moderate Crohn's Disease",
      applications: ["Safety Database", "EDC"],
      roles: ["Safety Reviewer", "Sponsor Read-Only"],
      status: "Submitted",
      requestType: "New Access",
      sponsor: "Northwind Therapeutics",
    },
    {
      id: "AR-2026-0004",
      submitted: "23 Aug 2026",
      time: "09:30",
      study: "GBX-2415",
      studyName: "Phase II Open-Label Extension — Oncology Basket",
      applications: ["LUP (Lab Upload Portal)"],
      roles: ["Lab User"],
      status: "Submitted",
      requestType: "New Access",
      sponsor: "Kestrel Oncology",
    },
    {
      id: "AR-2026-0003",
      submitted: "22 Aug 2026",
      time: "16:20",
      study: "GBX-2415",
      studyName: "Phase II Open-Label Extension — Oncology Basket",
      applications: ["CDISC/Programming Portal", "EDC"],
      roles: ["Statistical Programmer", "Biostatistician"],
      status: "More Info Required",
      requestType: "New Access",
      sponsor: "Kestrel Oncology",
    },
    {
      id: "AR-2026-0002",
      submitted: "20 Aug 2026",
      time: "14:50",
      study: "GBX-2201",
      studyName: "Phase III Ustekinumab in Moderate Crohn's Disease",
      applications: ["eTMF", "IWRS/RTSM"],
      roles: ["CRA/Monitor", "CRA/Monitor"],
      status: "Approved",
      requestType: "Additional Access",
      sponsor: "Northwind Therapeutics",
    },
    {
      id: "AR-2026-0001",
      submitted: "19 Aug 2026",
      time: "10:05",
      study: "GBX-2201",
      studyName: "Phase III Ustekinumab in Moderate Crohn's Disease",
      applications: ["EDC", "Training Management System"],
      roles: ["Investigator (PI)", "Investigator (PI)"],
      status: "Access Granted",
      requestType: "New Access",
      sponsor: "Northwind Therapeutics",
    },
  ];

  // --- Status chip colors ---
  const getStatusChip = (status) => {
    const chips = {
      Submitted: { bg: "#EDF0F5", color: "#48505F" },
      "Under Review": { bg: "#FEF3C7", color: "#B45309" },
      "More Info Required": { bg: "#FFEDD5", color: "#C2410C" },
      Approved: { bg: "#DBEAFE", color: "#1D4ED8" },
      "Access Granted": { bg: "#DCFCE7", color: "#15803D" },
      Closed: { bg: "#E2E8F0", color: "#334155" },
      Rejected: { bg: "#FEE2E2", color: "#B91C1C" },
      Deactivated: { bg: "#E7E5E4", color: "#57534E" },
    };
    const chip = chips[status] || chips["Submitted"];
    return {
      backgroundColor: chip.bg,
      color: chip.color,
      padding: "3px 11px 3px 9px",
      borderRadius: "999px",
      fontSize: "12.5px",
      fontWeight: 600,
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      whiteSpace: "nowrap",
    };
  };

  return (
    <>
      {/* Toolbar */}
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <i
            title={"Add New Request"}
            onClick={() => toggles.setToggle()}
            className={`fa-solid fa-plus-square CP`}
          />
          <div className="vr"></div>
          <div className="position-relative">
            <Form.Control
              type="Search"
              placeholder="ID, name, study, application"
              style={{ width: 250, padding: "3px 10px", fontSize: 13 }}
            />
            <CiSearch
              className="CP position-absolute bg-white"
              title="Search"
              style={{ width: 15, top: 4, right: 7, cursor: "pointer" }}
            />
          </div>
        </div>
        <div className="hstack gap-1">
          <button
            className="updateProfile"
            title="Filter"
            onClick={() => toggles.setToggle1()}
          >
            <FaFilter size={12} /> Filter
          </button>
          <button className="updateProfile" title="Export">
            <FaFileExport size={12} /> Export
          </button>
        </div>
      </div>

      {/* Table */}
      <SplitPane
        split="vertical"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 147px)" }}
      >
        <Table
          ref={tableRef}
          className={`w-100 m-0 custom-table`}
          hover
          striped
        >
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th>Request ID ▲</th>
              <th>Submitted</th>
              <th>Study</th>
              <th>Applications</th>
              <th>Role</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((req, index) => (
              <tr key={req.id}>
                <td>
                  <div>{req.id}</div>
                  <div>{req.requestType}</div>
                </td>
                <td>
                  <div>{req.submitted}</div>
                  <div>{req.time}</div>
                </td>
                <td>
                  <div>{req.study}</div>
                  <div>{req.sponsor}</div>
                </td>
                <td>
                  <div>
                    {req.applications.map((app) => (
                      <span key={app}>{app}</span>
                    ))}
                  </div>
                </td>
                <td>
                  <div>
                    {req.roles.map((role, i) => (
                      <div key={i} style={{ fontSize: 13 }}>
                        {role}
                        {i < req.roles.length - 1 && <br />}
                      </div>
                    ))}
                  </div>
                </td>
                <td>
                  <span style={getStatusChip(req.status)}>{req.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </SplitPane>
      {/* Modals */}
      <AddNewRequest Show={!toggles.toggle} Hide={toggles.setToggle} />
      <FilterRequestAccess Show={!toggles.toggle1} Hide={toggles.setToggle1} />
    </>
  );
};

export default AccessRequestPortal;
